import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import srOnly from '@helpers/srOnly';
import { link } from '@helpers/typography';
import SvgTick from '@img/icons/tick.svg';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  display: block;
  width: auto;

  & + & {
    margin-top: 15px;
  }
`;
const Tick = styled(SvgTick) `
  position: absolute;
  left: 3px;
  top: 50%;
  color: var(--accentColor);
  width: 9px;
  opacity: 0;
  z-index: 1;
  transform: translateY(-50%);
`;
const CheckboxItem = styled.label `
  position: relative;
  display: block;
  cursor: pointer;
`;
const CheckboxInput = styled.input `
  ${srOnly}

  &.focus-ring + span {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
  }
`;
const CheckboxText = styled.span `
  ${fonts.apparat.light};

  display: block;
  margin: 0;
  padding: 0 0 0 32px;
  color: var(--fgColor);
  font-size: ${fluid(16, 18)};
  line-height: ${fluid(26, 28)};

  [data-size='large'] & {
    padding: 2px 0 0 45px;

    &::before {
      height: 30px;
      width: 30px;
      border: 1px solid ${brand.secondary.blueGrey};
    }

    ${Tick} {
      left: 7px;
      width: 16px;
      color: ${brand.black};
    }
  }

  &:has(span:nth-child(2)) {
    span:nth-child(1) {
      font-weight: bold;
    }
  }

  span {
    display: block;

    a {
      ${link}
    }

    &:nth-child(2) {
      margin-top: 8px;
    }
  }

  &::after,
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    display: block;
    border-radius: 5px;
    box-sizing: border-box;
    height: 15px;
    width: 15px;
    transform: translateY(-50%);
  }

  &::before {
    border: 1px solid var(--fgColor);
    background-color: ${brand.white};
    z-index: 1;
  }

  ${CheckboxInput}:checked + & {
    ${Tick} {
      opacity: 1;
    }
  }

  ${CheckboxInput}:disabled + & {
    opacity: 0.5;
    cursor: not-allowed;
  }

  a {
    ${link}
  }
`;
export default {
    Container,
    CheckboxInput,
    CheckboxItem,
    CheckboxText,
    Tick,
};
